import { useCallback, useEffect, useRef } from 'react';

/**
 * return a callback to check if we're still mounted
 * via https://usehooks-ts.com/react-hook/use-is-mounted
 */
export function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
}
